import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { CallsManSVG } from '../../assets';

export const EmptyCalls = () => {
    return (
        <Box
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                gap: 70,
            }}
        >
            <Typography variant="h2" color="textPrimary">
                No hay llamadas recientes
            </Typography>
            <CallsManSVG
                style={{
                    height: 350,
                }}
            />
        </Box>
    );
};
